import { ReleaseNote } from "@/@types/app/ReleaseNote";
import { appApi } from "../api";

export async function getAllReleaseNotes() {
	const { data } = await appApi.get<ReleaseNote[]>("/releasenote");
	return data || [];
}

export async function getPendingReleaseNote() {
	const { data } = await appApi.get<ReleaseNote>("/releasenote/pending");
	return data || ({} as ReleaseNote);
}

export async function registerReleaseNote(releaseNote: ReleaseNote) {
	const response = await appApi.post(`/releasenote`, releaseNote);
	return response.status === 200;
}

export async function updateReleaseNote(releaseNote: ReleaseNote) {
	const response = await appApi.post(`/releasenote/${releaseNote.id}`, releaseNote);
	return response.status === 200;
}
